<template>
  <f7-page @page:beforeremove="onPageBeforeRemove">
    <f7-popup class="demo-popup" :opened="popupOpened" @popup:closed="closePopup">
      <f7-page>
        <f7-navbar title="Unauthorized!">
          <f7-nav-right>
            <f7-link popup-close>Close</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block>
          <img src="../../assets/unauthorized.png" />
          <div class="innerDiv">
            <p style="display:block">{{ errorMsg }}</p>
            <a
              href="javascript:void(0)"
              class="btn btn-default"
              @click="logout()"
              target="_self"
            >Click here to login again.</a>
          </div>
        </f7-block>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>
<style scoped>
.innerDiv a.btn {
  background: #17a2b8 !important;
  color: #ffff !important;
}
.innerDiv {
  padding-top: 10px;
}
p {
  display: block;
  /* padding: 10px 10px 6px 10px; */
  /* margin-top: 29px; */
  position: relative;
  top: -7px;
}
img {
  height: 30px;
  border: none !important;
}
</style>

<script>
export default {
  name: "Unauthorized",
  data() {
    return {
      popupOpened: true,
      errorMsg: localStorage.getItem("errorMsg") | ""
    };
  },
  methods: {
    closePopup() {
      // window.location.href = window.location.origin;
      let paths = location.pathname.replace("/", "").split("/");
      window.location.href = `${window.location.origin}/${paths[0]}/${paths[1]}`;
      // this.popupOpened = false;
    },
    logout() {
      //  window.location.href = "http://v1.datetix.com/employee/logout";
      window.localStorage.clear();
      let paths = location.pathname.replace("/", "").split("/");
      window.location.href = `${window.location.origin}/${paths[0]}/${paths[1]}`;
    },
    onPageBeforeRemove() {
      const self = this;
      // Destroy popup when page removed
      if (self.popup) self.popup.destroy();
    }
  },
  mounted: function() {
    const app = this;
    app.errorMsg = localStorage.getItem("errorMsg");
  }
};
</script>
